module.exports = __webpack_public_path__ + "img/Icon-Timer-white.db0e166e.svg";